/**
 * @fileOverview Handles the loading state for various parts of other state.
 * This is like a meta reducer. Every object in state's id will be globally
 * unique, you can find out its loading state by quering this state
 */

function loadingReducer(state = {}, action){
  if (action.type == 'SET_LOADING'){
    state = Object.assign({}, state)
    state[action.payload.id] = action.payload.isLoading
  }
  return state
}

export default loadingReducer

/**
 * Set an object's loading state
 * @param {string} id The object id
 * @param {boolean} isLoading Whether or not it's currently loading
 */
export function setLoading(id, isLoading){
  return {
    type: 'SET_LOADING',
    payload: {
      id,
      isLoading,
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/loading/reducer.js